import styled from 'styled-components';

export const FooterCont = styled.footer`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-shrink: 1;
  font-size: 0.75rem;
  /* color: white; */
  color: #f7f4f3;
  height: 3rem;
  background-color: #31263e;
  align-items: center;
  /* mask-image: linear-gradient(to bottom, transparent 5%, #31263e 20%); */
`;
